import { useEffect, useState } from 'react';
import { Highlight } from '@mantine/core';
import { IConsultationOutcome } from '../../hooks/promises/getConsultationOutcomes';
import TextField from '../TextField/TextField';

export interface ICheckboxProps {
  item: IConsultationOutcome;
  onClick?: (val: boolean) => void;
  startChecked: boolean;
  disabled: boolean;
  userSearchString: string;
  onInputText?: (val: string) => void;
  defaultText?: string;
}

export function Checkbox({
  item,
  onClick,
  disabled,
  onInputText,
  startChecked,
  defaultText,
  userSearchString,
}: ICheckboxProps) {
  const [checked, setChecked] = useState<boolean>(false);
  const [text, setText] = useState<string>(defaultText ?? '');
  useEffect(() => {
    if (onClick) onClick(checked);
  }, [checked]);
  useEffect(() => setChecked(startChecked), []);

  let body;

  if (onInputText)
    body = (
      <TextField
        text={text}
        setText={(x) => {
          setText(x);
          onInputText(x);
          setChecked(true);
        }}
        disabled={disabled && !checked}
        className="w-full"
        size="md"
      />
    );
  else
    body = (
      <Highlight
        className={`leading-6 text-[1.1rem] select-none ${
          checked ? 'font-semibold text-primary-500' : ''
        } ${disabled ? 'text-gray-400 cursor-not-allowed' : 'cursor-pointer'}`}
        onClickCapture={() => setChecked((c) => !(disabled || c))}
        highlight={userSearchString}
      >
        {item.consultationOutcomeDescriptionShort}
      </Highlight>
    );

  return (
    <div className="flex flex-row items-start gap-1">
      <input
        type="checkbox"
        id={item.consultationOutcomeDescription}
        checked={checked}
        disabled={disabled && !checked}
        onChange={() => setChecked((x: boolean) => !x)}
        className={`mr-2 transform scale-[1.2] translate-y-1.5 ${
          disabled && !checked ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
      />
      {body}
    </div>
  );
}
